import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import Sidebar from "components/sidebar";
import Header from "components/header";
import { AppPath } from "utils/constants";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NotificationPart } from "components/menuNoti";

const SidebarLayout = () => {
  const { loginData } = useAuth();
  const [sidebarToggle, setSidebarToggle] = useState(false);

  if (!loginData.isLogin) {
    return <Navigate to={AppPath.Login} replace />;
  }

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle);
  };

  return (
    <>
      <div className="flex h-screen overflow-hidden">
        <ToastContainer />
        <Sidebar
          sidebarToggle={sidebarToggle}
          handleSidebarToggle={handleSidebarToggle}
          loginData={loginData}
        />
        <NotificationPart />
        <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
          <Header
            sidebarToggle={sidebarToggle}
            handleSidebarToggle={handleSidebarToggle}
          />
          <main>
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default SidebarLayout;
